import type { LocalePack } from './types.js';

/** French (Français) */
export const fr: LocalePack = {
  headerTitle: 'Éditeur de photos',
  headerSubtitle: 'Modifiez votre image en toute simplicité',
  applyButton: 'Appliquer',
  cancelButton: 'Fermer',
  undo: 'Annuler',
  redo: 'Rétablir',
  fullscreen: 'Plein écran',
  fit: 'Ajuster',
  zoomTooltip: 'Zoom · +/− · 0 ajuster · 1 100 %',

  emptyStateTitle: 'Déposez une image ou cliquez pour téléverser',
  emptyStateSubtitle: 'Pris en charge : PNG, JPEG, HEIC',

  calloutLabelText: 'Étiquette',

  tool: {
    select: 'Sélectionner',
    crop: 'Recadrer',
    draw: 'Dessiner',
    eraser: 'Gomme',
    text: 'Texte',
    shapes: 'Formes',
    callout: 'Note',
    filters: 'Filtres',
    adjust: 'Ajuster',
    move: 'Déplacer',
    pen: 'Stylo',
    zoom: 'Zoom',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    rotateLeft: 'Pivoter à gauche',
    rotateRight: 'Pivoter à droite',
    flipH: 'Miroir H',
    flipV: 'Miroir V',
    reset: 'Réinitialiser',
  },

  shape: {
    circle: 'Cercle',
    ellipse: 'Ellipse',
    square: 'Carré',
    rectangle: 'Rectangle',
    arrow: 'Flèche',
    polyline: 'Ligne',
  },

  filter: {
    none: 'Original',
    grayscale: 'N & B',
    sepia: 'Sépia',
    vintage: 'Vintage',
    cool: 'Froid',
    warm: 'Chaud',
    invert: 'Inverser',
  },

  props: {
    title: {
      draw: 'Dessiner',
      eraser: 'Gomme',
      text: 'Texte',
      crop: 'Recadrer',
      shapes: 'Formes',
      callout: 'Note',
      filters: 'Filtres',
      adjust: 'Ajuster',
      move: 'Déplacer',
    },
    aspectRatio: "Format d'image",
    applyCrop: 'Appliquer le recadrage',
    cancel: 'Annuler',
    shape: 'Forme',
    preset: 'Préréglage',
    resetEffects: 'Réinitialiser les effets',
    resetAdjustments: 'Réinitialiser les ajustements',
    deleteSelected: 'Supprimer la sélection',
    colors: 'Couleurs',
    recent: 'Récent',
    customColor: 'Couleur personnalisée',
    brushSize: 'Taille du pinceau',
    strokeWidth: 'Épaisseur du trait',
    opacity: 'Opacité',
    eraserSize: 'Taille de la gomme',
    fontSize: 'Taille de la police',
    brightness: 'Luminosité',
    contrast: 'Contraste',
    saturation: 'Saturation',
    blur: 'Flou',
    quickActions: 'Actions rapides',
    hintMove:
      'Faites glisser pour déplacer · pincez ou faites défiler pour zoomer · choisissez un outil pour commencer.',
    hintEraser: 'Appuyez ou faites glisser sur une annotation pour la supprimer.',
  },
};
